import type { Field } from "@/types/Field";
import {
  isAllowlistExempt,
  isAllowlistableKey,
} from "@/lib/authz/fieldAllowlist";

/**
 * Read-only render of a saved view's columns as chips. Columns the role will
 * see after the import render as normal chips — the allowlistable ones AND the
 * exempt ones (row ids, action columns) the list shows regardless; columns
 * nothing can model any more (a deleted custom field) render muted +
 * struck-through so the admin sees the truthful result before importing.
 * `labelFor` resolves a raw field name to a display label (supplied by the
 * modal: custom → translation, fixed → guest-fields i18n).
 */
export function ViewFieldsPreview({
  fields,
  allFields,
  labelFor,
  skippedTitle,
}: {
  fields: string[];
  allFields: Field[];
  labelFor: (name: string) => string;
  /** Tooltip shown on dropped chips, e.g. "wird übersprungen". */
  skippedTitle: string;
}) {
  return (
    <ul className="flex flex-row flex-wrap gap-1.5">
      {fields.map((n, idx) => {
        const def = allFields.find((f) => f.name === n);
        const key = def?.additionalField ? `additionalFields.${n}` : n;
        const kept = isAllowlistExempt(key) || isAllowlistableKey(key);
        return (
          <li
            key={`${n}-${idx}`}
            title={kept ? undefined : skippedTitle}
            className={`flex items-center h-min border py-1 px-2 rounded-lg w-max body-3-regular ${
              kept
                ? "outline-quaternary font-secondary"
                : "outline-quaternary font-quaternary line-through"
            }`}
          >
            {labelFor(n)}
          </li>
        );
      })}
    </ul>
  );
}
